/**
 * Created by markusr on 3.6.2015.
 * Modified by markusr on 4.12.2015.
 * Modified by markusr on 25.5.2016 (GP-549)
 * Known issues: -
 * @component {"type":"AnswerPopup","version":"1.3"}
 */

define('component-answer-popup',['require','knockout','jquery'],function(require) {
    'use strict';

    var ko = require('knockout'),
        $ = require('jquery');

    return function(parentVM, dataContext) {

        var self		    	= this,
            tvm                 = parentVM.training,
            entityVM = parentVM.entity,
            component           = null,
            componentContent    = null,
            emails              = null;

        self.exists             = ko.observable(false);
        self.imageSrc           = ko.observable('');
        self.buttonLabel        = ko.observable('');
        self.printInstructions  = ko.observable('');
        self.printButtonLabel   = ko.observable('');
        self.sendInstructions   = ko.observable('');
        self.sendButtonLabel    = ko.observable('');
        self.answersHeading     = ko.observable('');
        self.componentHTML      = ko.observable('');
        self.editableEmails     = ko.observable(true);

        self.imageUrl           = ko.computed(function() {
            return 'url(' + self.imageSrc() + ')';
        });
        self.tasksAndAnswers    = ko.observableArray([]);

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.showAnswers = function() {
            saveAnswersToLocalstorage();

            if (win) win.close();

            var win = window.open("custom/popups/answerpopup.html","","toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=700,height=700");
        };

        function saveAnswersToLocalstorage(){
            // TODO: Don't save emails.
            // get answer innerHTML with jQuery from hidden template
            var buttonHtml = $('#answer-popup-html .buttons').html();
            localStorage.removeItem('workbook-buttonHtml');
            localStorage.setItem('workbook-buttonHtml', encodeURI(buttonHtml));

            var answersHtml = $('#answer-popup-html .answers').html();
            localStorage.removeItem('workbook-answersHtml');
            localStorage.setItem('workbook-answersHtml', encodeURI(answersHtml));
        }

        function setAnswers(){
            var answers = tvm.getTasksAndAnswers();
            self.tasksAndAnswers = ko.observableArray([]);
            if(answers && answers.length > 0){
                answers.forEach(function(answer){
                    if(answer.componentsKinds.indexOf("OpenQuestionEmails") == -1) {
                        self.tasksAndAnswers.push(answer);
                    }else{
                        var emailArr = [];
                        if(answer.options.length){
                            answer.options.forEach(function(option){
                                if(option.answerText.length > 4) emailArr.push(option.answerText);
                            });
                        }
                        emails = emailArr.join(", ");
                    }
                });
            }
        }

        ko.bindingHandlers.answerPopupContent = {
            init: function() {
                return {
                    controlsDescendantBindings: true
                };
            },
            update: function(container, valueAccessor, allBindings, viewModel, bindingContext) {

                if (!entityVM.ID()) {
                    return;
                }

                ko.virtualElements.emptyNode(container);
                container.innerHTML = self.componentHTML();
                ko.applyBindingsToDescendants(bindingContext.createChildContext(bindingContext.$rawData), container);
            }
        };

        self.pageChanged = function(){

            component = tvm.getComponentsByKind('AnswerPopup')[0];

            if(component){
                self.exists(true);
                componentContent = component.content;

                setAnswers();

                localStorage.removeItem('workbook-popupTitle');
                localStorage.setItem('workbook-popupTitle', encodeURI(componentContent.popupTitle));

                localStorage.removeItem('workbook-popupHeading');
                localStorage.setItem('workbook-popupHeading', encodeURI(componentContent.popupHeading));

                localStorage.removeItem('workbook-answers');
                localStorage.setItem('workbook-answers', encodeURI($('#answer-popup-html #answers').html()));

                localStorage.removeItem('workbook-emailTitle');
                localStorage.setItem('workbook-emailTitle', encodeURI(componentContent.emailTitle));

                localStorage.removeItem('workbook-emailSender');
                localStorage.setItem('workbook-emailSender', encodeURI(componentContent.emailSender));

                localStorage.removeItem('workbook-emailRecipients');
                localStorage.setItem('workbook-emailRecipients', encodeURI(emails));

                localStorage.removeItem('workbook-sending');
                localStorage.setItem('workbook-sending', encodeURI(componentContent.sending));

                localStorage.removeItem('workbook-sendSuccess');
                localStorage.setItem('workbook-sendSuccess', encodeURI(componentContent.sendSuccess));

                localStorage.removeItem('workbook-sendFail');
                localStorage.setItem('workbook-sendFail', encodeURI(componentContent.sendFail));

                localStorage.removeItem('workbook-editableEmails');
                localStorage.setItem('workbook-editableEmails', encodeURI(componentContent.editableEmails));

                if(componentContent.buttonLabel) {
                    self.buttonLabel(componentContent.buttonLabel);
                }
                if(componentContent.printInstructions) {
                    self.printInstructions(componentContent.printInstructions);
                }
                if(componentContent.printButtonLabel) {
                    self.printButtonLabel(componentContent.printButtonLabel);
                }
                if(componentContent.sendInstructions) {
                    self.sendInstructions(componentContent.sendInstructions);
                }
                if(componentContent.sendButtonLabel) {
                    self.sendButtonLabel(componentContent.sendButtonLabel);
                }
                if(componentContent.answersHeading) {
                    self.answersHeading(componentContent.answersHeading);
                }
                if(componentContent.editableEmails != undefined) {
                    self.editableEmails(componentContent.editableEmails);
                }

                self.componentHTML(componentContent.html);

            } else if(self.exists){
                self.exists(false);
                self.imageSrc('');
                self.tasksAndAnswers([]);
                self.componentHTML('');
                emails = null;
            }
        };

        // called once at the end of trainingVM
        function init() {
            tvm.answerPopup = self;

            // pageChanged won't otherwise be called on the 1st page
            self.pageChanged();
        }

        init();
    }
});


